import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorCurrencyNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface ICurrencyModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const ICurrencyFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useCurrencyHookNae(id: number) : ICurrencyModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorCurrencyNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Currency.schema,
        fields: ICurrencyFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
